import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonAction, TopButtonPointEdit, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../utilities/TabUtilities";
var tinycolor = require("tinycolor2");

export default class ZnizkiTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.renderEsprzedaz = this.renderEsprzedaz.bind(this)
        this.renderuoperatora = this.renderuoperatora.bind(this)
        this.renderUKierowcy = this.renderUKierowcy.bind(this)
        this.formatTrasa = this.formatTrasa.bind(this)
    }

    renderButtonyAkcji(cell,row){
        return(
            <div>
                <TopButtonPointEdit onClick={()=>{this.props.handleEdytuj(row)}} titleContent={'Edytuj zniżkę'} disabled={row.rodz==='PROM' || row.rodz==='BASE' || row.rodz==='BASEM'} />
                <TopButtonPointRemove onClick={()=>{this.props.handleUsun(row)}} titleContent={'Usuń zniżkę'} disabled={row.rodz==='PROM' || row.rodz==='BASE' || row.rodz==='BASEM'}/>
            </div>
        )
    }

    renderTakNie(cell,row){
        if(Boolean(cell)) return <span><i className={'fa fa-check'} style={{color:'forestgreen'}}></i> tak</span>
        else return <span><i className={'fa fa-times'} style={{color:'firebrick'}}></i> nie</span>
    }

    renderRodzajZnizki(cell,row){
        //(tinycolor(row.kolor)).isDark()?'#fff':'#000'
        return <span className={'label label-ebus-default'} style={{background:row.kolor, color: '#fff'}}>{cell}</span>
    }

    renderUKierowcy(cell,row){
        if (Boolean(cell)) {
            return (
                <div title={'Kliknij aby zmienić status'}>
                    <TopButtonAction block btnColor={'default'} onClick={() => {
                        this.props.handleZmienUKierowcy(row, false)
                    }} text={'tak'} iconType={'fa fa-check'} className={'btn-status-dostepny'}/>
                </div>
            )
        }
        else{
            return (
                <div title={'Kliknij aby zmienić status'}>
                    <TopButtonAction block btnColor={'default'} onClick={() => {
                        this.props.handleZmienUKierowcy(row, true)
                    }} text={'nie'} iconType={'fa fa-times'} className={'btn-status-niedostepny'}/>
                </div>
            )
        }
    }


    renderEsprzedaz(cell,row){
        if (Boolean(cell)) {
            return (
                <div title={'Kliknij aby zmienić status'}>
                    <TopButtonAction block btnColor={'default'} onClick={() => {
                        this.props.handleZmienEsprzedaz(row, false)
                    }} text={'tak'} iconType={'fa fa-check'} className={'btn-status-dostepny'}/>
                </div>
            )
        }
        else{
            return (
                <div title={'Kliknij aby zmienić status'}>
                    <TopButtonAction block btnColor={'default'} onClick={() => {
                        this.props.handleZmienEsprzedaz(row, true)
                    }} text={'nie'} iconType={'fa fa-times'} className={'btn-status-niedostepny'}/>
                </div>
            )
        }
    }


    renderuoperatora(cell,row){
        if (Boolean(cell)) {
            return (
                <div title={'Kliknij aby zmienić status'}>
                    <TopButtonAction block btnColor={'default'} onClick={() => {
                        this.props.handleZmienuoperatora(row, false)
                    }} text={'tak'} iconType={'fa fa-check'} className={'btn-status-dostepny'}/>
                </div>
            )
        }
        else{
            return (
                <div title={'Kliknij aby zmienić status'}>
                    <TopButtonAction block btnColor={'default'} onClick={() => {
                        this.props.handleZmienuoperatora(row, true)
                    }} text={'nie'} iconType={'fa fa-times'} className={'btn-status-niedostepny'}/>
                </div>
            )
        }
    }

    formatTrasa(cell,row){
        if(cell===0){
            return 'wszystkie trasy'
        }
        else{
            let trasa = this.props.trasy.find(t=>t.idTr==cell)
            if(trasa){
              return trasa.nazTr
            }
            else return cell
        }
    }

    render() {

        let statusy = {
            1: 'tak',
            0: 'nie'
        }

        let esprzedaz = {
            true: 'tak',
            false: 'nie',
        }

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idZn' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='rodz' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderRodzajZnizki}
                    >Rodzaj</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazZniz' dataSort
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} dataFormat={(cell,row)=><span style={{fontSize:12}}>{cell}</span>}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Nazwa zniżki</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazDruk' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataFormat={(cell,row)=><span style={{fontSize:12}}>{cell}</span>}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Nazwa na druku</TableHeaderColumn>
                    <TableHeaderColumn dataField='idTr' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'SelectFilter', options: this.props.trasyTS, selectText: 'Wybierz', condition: 'eq'}}
                                       dataFormat={this.formatTrasa}
                    >Trasa</TableHeaderColumn>
                    <TableHeaderColumn dataField='proc' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Procent</TableHeaderColumn>
                    <TableHeaderColumn dataField='ustawowa'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                       filter={ { type: 'SelectFilter', options: esprzedaz, selectText: '' } } formatExtraData={ esprzedaz }
                                       dataFormat={this.renderTakNie}
                    >Ustawowa?</TableHeaderColumn>
                    <TableHeaderColumn dataField='handlowa'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                       filter={ { type: 'SelectFilter', options: esprzedaz, selectText: '' } } formatExtraData={ esprzedaz }
                                       dataFormat={this.renderTakNie}
                    >Handlowa?</TableHeaderColumn>
                    <TableHeaderColumn dataField='czyMies'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                       filter={ { type: 'SelectFilter', options: statusy, selectText: '' } } formatExtraData={ statusy }
                                       dataFormat={this.renderTakNie}
                    >Miesięczny?</TableHeaderColumn>
                    <TableHeaderColumn dataField='uoperatora'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                       filter={ { type: 'SelectFilter', options: esprzedaz, selectText: '' } } formatExtraData={ esprzedaz }
                                       dataFormat={this.renderuoperatora}
                    >U operatora?</TableHeaderColumn>
                    <TableHeaderColumn dataField='esprzedaz'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                       filter={ { type: 'SelectFilter', options: esprzedaz, selectText: '' } } formatExtraData={ esprzedaz }
                                       dataFormat={this.renderEsprzedaz}
                    >Esprzedaż?</TableHeaderColumn>
                    <TableHeaderColumn dataField='ukierowcy'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                       filter={ { type: 'SelectFilter', options: esprzedaz, selectText: '' } } formatExtraData={ esprzedaz }
                                       dataFormat={this.renderUKierowcy}
                    >U kierowcy?</TableHeaderColumn>
                    <TableHeaderColumn dataField='idZn'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/znizki/components/ZnizkiTable.js